import Category from "views/Category";
import Customers from "views/Customers";
import Dashboard from "views/Dashboard";
import Documents from "views/Documents";
import RelationshipType from "views/RelationshipType";
import FAQ from "views/FAQ";
import Invoices from "views/Invoices";
import Location from "views/Location";
import Orders from "views/Orders";
import Organization from "views/Organization";
import Packages from "views/Packages";
import DealsOffers from "views/DealsOffers";
import Reports from "views/Report/Reports";
import Settings from "views/Settings";
import LifestyleSettings from "views/LifestyleSettings";
import SPCommissions from "views/SPCommissions";
import ComingSoon from "views/ComingSoon";
import BehaviourGrandApp from "views/BehaviourGrandApp";
import Users from "views/Users";
import AppPreference from "views/AppPreference";
import HomeGreeting from "views/HomeGreeting";
import Subscription from "views/Subscription";
import ReferAndEarn from "views/ReferAndEarn";
import CartData from "views/ReferAndEarn/panels/CartData";
import GradAppAutologin from "views/GradAppAutologin";
import IframeLauncherComponent from "views/ReactExample"
import Subscription24X7 from "./views/Subscription24X7";
import LifestyleMembership from "./views/LifestyleMembership";
import LifestyleSessions from "views/LifestyleSessions";
import ClassSessions from "views/ClassSessions"
import ClassActivity from "views/ClassActivity"


import {
    MdAccountBox, MdAssignmentTurnedIn, MdDescription, MdDomain,
    MdInsertChart, MdLibraryBooks,
    MdLocalMall,
    MdLocalOffer,
    MdLocalShipping,
    MdLocationOn, MdMonetizationOn, MdPeople, MdReceipt, MdSettings,
    MdToc, MdTransferWithinAStation
} from "react-icons/md";
import ServiceProviderNew from "./views/ServiceProviderNew/ServiceProviderNew";
import Chat from "./views/Chat/Chat";
import MemberProfile from "views/MemberProfile";
import GenderType from "views/GenderType";
import CommChannel from "views/CommunicationChannel";
import AccessLevel from "views/AccessLevel";

const routes = [
    {
        name: "Home",
        path: "/home",
        Icon: <MdInsertChart size="14" color="#23B7E5"/>,
        component: <Dashboard/>
    },
    {
        name: "Users",
        path: "/users",
        Icon: <MdAccountBox size="14" color="#528FF0"/>,
        component: <Users/>,
        break: true
    },
    {
        name: "Customers",
        path: "/customers",
        Icon: <MdPeople size="14" color="#FBE165"/>,
        component: <Customers/>
    },
    {
        name: "Refer & Earn",
        path: "/refer-earn",
        Icon: <MdMonetizationOn size="14" color="#528FF0"/>,
        component: <ReferAndEarn/>
    },
    {
        name: "Subscription",
        path: "/subscription",
        Icon: <MdAssignmentTurnedIn size="14" color="#23B7E5"/>,
        component: <Subscription/>
    },
    {
        name: "Orders",
        path: "/orders",
        Icon: <MdAssignmentTurnedIn size="14" color="#23B7E5"/>,
        component: <Orders/>
    },
    {
        name: "Cart",
        path: "/cartdata",
        Icon: <MdReceipt size="14" color="#27C24C"/>,
        component: <CartData/>,
        break: true
    },
    {
        name: "Organization",
        path: "/organization",
        Icon: <MdDomain size="14" color="#27C24C"/>,
        component: <Organization/>
    },
    // {
    //     name: "Service Providers (SP)",
    //     path: "/service-providers",
    //     Icon: <MdTransferWithinAStation size="14" color="#FBE165"/>,
    //     component: <ServiceProviders/>
    // },
    {
        name: "Service Providers (SP)",
        path: "/service-providers-new",
        Icon: <MdTransferWithinAStation size="14" color="#FBE165"/>,
        component: <ServiceProviderNew/>
    },
    {
        name: "SP Commissions",
        path: "/sp-commisions",
        Icon: <MdDescription size="14" color="#F19A5E"/>,
        component: <SPCommissions/>,
        break: true
    },
    {
        name: "Behaviour & Monitoring",
        path: "/grand-app-behaviour",
        Icon: <MdDescription size="14" color="#F19A5E"/>,
        component: <IframeLauncherComponent />,
        break: true
    },
    {
        name: "24X7 Member Profile",
        path: "/member-profile",
        Icon: <MdAccountBox size="14" color="#F19A5E"/>,
        component: <MemberProfile/>,
        break: false
    },
    {
        name: "24X7 Subscription",
        path: "/tfour-sub",
        Icon: <MdDescription size="14" color="#F19A5E"/>,
        component: <Subscription24X7 />,
        break: true
    },
    {
        name: "LifeStyle Membership",
        path: "/tstyle-member",
        Icon: <MdDescription size="14" color="#F19A5E"/>,
        component: <LifestyleMembership />,
        break: false
    },
    {
        name: "Lifestyle Sessions",
        path: "/class-sessions",
        Icon: <MdDescription size="14" color="#F19A5E"/>,
        component: <ClassSessions />,
        break: false
    },
    {
        name: "LifeStyle Activities",
        path: "/lifestyle-activities",
        Icon: <MdDescription size="14" color="#F19A5E"/>,
        component: <ClassActivity />,
        break: true
    },
    {
        name: "Relationship Types",
        path: "/relationship-types",
        Icon: <MdDescription size="14" color="#F19A5E"/>,
        component: <RelationshipType />,
        break: false
    },
    {
        name: "Gender Types",
        path: "/gender-types",
        Icon: <MdDescription size="14" color="#F19A5E"/>,
        component: <GenderType />,
        break: false
    },
    {
        name: "Communication Channels",
        path: "/communication-channels",
        Icon: <MdDescription size="14" color="#F19A5E"/>,
        component: <CommChannel />,
        break: false
    },
    {
        name: "Information Access Level",
        path: "/information-access-level",
        Icon: <MdDescription size="14" color="#F19A5E"/>,
        component: <AccessLevel />,
        break: true
    },
    {
        name: "Category",
        path: "/category",
        Icon: <MdToc size="14" color="#528FF0"/>,
        component: <Category/>
    },
    {
        name: "Packages",
        path: "/packages",
        Icon: <MdLocalMall size="14" color="#27C24C"/>,
        component: <Packages/>
    },
    {
        name: "Discounts",
        path: "/discounts",
        Icon: <MdLocalOffer size="14" color="#27C24C"/>,
        component: <DealsOffers/>,
        break: true
    },
    {
        name: "Home Greeting",
        path: "/home-greeting",
        Icon: <MdLocalShipping size="14" color="#F19A5E"/>,
        component: <HomeGreeting/>
    },
    {
        name: "App Preferences",
        path: "/app-preferences",
        Icon: <MdLocalShipping size="14" color="#F19A5E"/>,
        component: <AppPreference/>
    },
    {
        name: "Location",
        path: "/location",
        Icon: <MdLocationOn size="14" color="#FBE165"/>,
        component: <Location/>
    },
    {
        name: "Documents",
        path: "/documents",
        Icon: <MdReceipt size="14" color="#F19A5E"/>,
        component: <Documents/>
    },
    {
        name: "FAQ",
        path: "/faq",
        Icon: <MdLocalShipping size="14" color="#F19A5E"/>,
        component: <FAQ/>,
        break: true
    },
    {
        name: "Chat",
        path: "/chat",
        Icon: <MdMonetizationOn size="14" color="#528FF0"/>,
        component: <Chat/>
    },
    // {
    //     name: "Reports",
    //     path: "/reports",
    //     Icon: <MdLibraryBooks size="14" color="#F05050"/>,
    //     component: <Reports/>
    // },
    // {
    //     name: "Service Providers (SP)",
    //     path: "/service-providers-new",
    //     Icon: <MdLibraryBooks size="14" color="#F05050"/>,
    //     component: <ServiceProviderNew/>
    // },
    {
        name: "Settings",
        path: "/settings",
        Icon: <MdSettings size="14" color="#FBE165"/>,
        component: <Settings/>
    },
    {
        name: "Lifestyle Setting",
        path: "/lifestyle-settings",
        Icon: <MdSettings size="14" color="#FBE165"/>,
        component: <LifestyleSettings/>
    },
    // {
    //     name: "Class Session",
    //     path: "/class-sessions",
    //     Icon: <MdSettings size="14" color="#FBE165"/>,
    //     component: <ClassSessions/>
    // }
];

export default routes;
